import { useCallback } from 'react';
import { useSignOut } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';

const useLogout = () => {
  const signOut = useSignOut();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    signOut();
    navigate('/auth/sign-in');
  }, [signOut, navigate]);

  return { handleLogout };
};

export default useLogout;
